export const CLAIM_NAMES = {
    ADMINISTRATOR:  'Administrator',
    SUPER_ADMIN_CLIENT: 'SuperAdminClient',
    SYSTEM_ADMIN:   'SystemAdmin',
    REGION_ADMIN:   'RegionAdmin',
    USER_ADMIN:    'UserAdmin',
    CLIENT_ADMIN:    'ClientAdmin',
    CULTURE_ADMIN:  'CultureAdmin',
    BROKER_USER:    'BrokerUser',
    CREATE_CLIENT:  'CreateClient'
};

export const ROLE_NAMES = {
    CLIENT_ADMIN: 'ClientAdmin',
    CLIENT_INTERNAL_USER: 'ClientInternalUser',
    CLIENT_INTERNAL_USER_READ_ONLY: 'ClientInternalUserReadOnly',
    CLIENT_EXTERNAL_USER: 'ClientExternalUser',
    CLIENT_EXTERNAL_USER_READ_ONLY: 'ClientExternalUserReadOnly'
};

export const EXTERNAL_ROLES = [
    ROLE_NAMES.CLIENT_EXTERNAL_USER,
    ROLE_NAMES.CLIENT_EXTERNAL_USER_READ_ONLY
];

export const INTERNAL_ROLES = [
    ROLE_NAMES.CLIENT_INTERNAL_USER,
    ROLE_NAMES.CLIENT_INTERNAL_USER_READ_ONLY
];
export const ACCESS_CLIENTS_CLAIMS = [
    CLAIM_NAMES.CLIENT_ADMIN,
    CLAIM_NAMES.REGION_ADMIN,
    CLAIM_NAMES.CREATE_CLIENT,
];

export const HIGH_PRIVILEGE_ROLES = [
    CLAIM_NAMES.SUPER_ADMIN_CLIENT,
    CLAIM_NAMES.SYSTEM_ADMIN,
    CLAIM_NAMES.REGION_ADMIN,
    CLAIM_NAMES.CLIENT_ADMIN,
    CLAIM_NAMES.ADMINISTRATOR
];

